<template>
  <div
    :id="`mars3d-container${mapKey}`"
    :class="[
      'mars3d-container',
      customClass,
      { 'mars3d-container-compare-rh': compare },
    ]"
  ></div>
</template>

<script>
import Vue from "vue";

const mars3d = window.mars3d;

// 为了方便使用,绑定到原型链，在其他vue文件，直接 this.mars3d 来使用
Vue.prototype.mars3d = window.mars3d;
Vue.prototype.Cesium = window.mars3d.Cesium;

export default {
  name: "mars3dViewer",

  props: {
    // 初始化配置参数
    url: String,
    widgetUrl: String,

    // 地图唯一性标识
    mapKey: {
      type: String,
      default: "",
    },

    // 自定义参数
    options: Object,

    // 是否分屏显示
    compare: {
      type: Boolean,
      default: false,
    },

    // 是否插入到body元素上
    appendToBody: {
      type: Boolean,
      default: false,
    },

    // 自定义css类名
    customClass: {
      type: String,
      default: "",
    },
  },

  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }

    if (this.mapKey) {
      this.initMars3d(this.options);
    } else {
      this.mars3d.Resource.fetchJson({ url: this.url }).then((data) => {
        this.initMars3d(data.map3d); // 构建地图
      });
    }
  },

  destroy() {
    // this[`map${this.mapKey}`].destroy();
    // delete this[`map${this.mapKey}`];
  },

  methods: {
    initMars3d(options) {
      if (this[`map${this.mapKey}`]) return;

      const mapOptions = {
        ...options,
        ...this.options,
      };

      // 创建三维地球场景
      const map = new this.mars3d.Map(
        `mars3d-container${this.mapKey}`,
        mapOptions
      );
      const zoom = new this.mars3d.control.Zoom({
        insertIndex: 1, //插入的位置顺序
        zoomInClass: "fa fa-plus",
        zoomOutClass: "fa fa-minus",
      });

      const compass = new this.mars3d.control.Compass({
        top: "5px",
        right: "63px",
      });
      map.addControl(compass);
      map.addControl(zoom);

      this[`map${this.mapKey}`] = map;

      // 挂载到全局对象下，所有组件通过 this.map 访问
      // Vue.prototype[`map${this.mapKey}`] = map

      // 绑定对alert的处理，右键弹出信息更美观。
      window.haoutil = window.haoutil || {};
      window.haoutil.msg = (msg) => {
        this.$message.success(msg);
      };
      window.haoutil.alert = (msg) => {
        this.$message.success(msg);
      };

      // 抛出事件
      this.$emit("onload", map);

      map.flyHome({ duration: 0 });
      //开场动画
      map.openFlyAnimation({
        // duration1:4,
        // easingFunction1: Cesium.EasingFunction.QUINTIC_IN_OUT,
        callback: function () {
          //动画播放完成后回调
        },
      });
      Vue.prototype.map = map;
    },
  },
};
</script>

<style >
.mars3d-container {
  height: 100%;
  overflow: hidden;
}
</style>
